import cx from 'classnames'
import { Fragment } from 'react'

import s from './prize.module.scss'

export const Prize = () => {
  return (
    <Fragment>
      <div className={s.prize}>
        <div className={s.puffy} />
        <div className={s.fire} />
        <div className={s.gamepad} />
        <div className={s.check} />
        <div className={s.coin} />
        <div className={s.label}>Total Prize</div>
        <div className={s.total}>$20,500</div>
      </div>
      <div className={s.including}>
        <div className={s.heading}>Including:</div>
        <div className={s.grid}>
          <div className={cx(s.item, s.first)}>
            <div className={s.prizeValue}>
              <div className={s.label}>First Prize</div>
              <div className={s.value}>$8,000</div>
            </div>
          </div>
          <div className={cx(s.item, s.second)}>
            <div className={s.prizeValue}>
              <div className={s.label}>Second Prize</div>
              <div className={s.value}>$5,000</div>
            </div>
          </div>
          <div className={cx(s.item, s.third)}>
            <div className={s.prizeValue}>
              <div className={s.label}>Third Prize</div>
              <div className={s.value}>$3,000</div>
            </div>
          </div>
          <div className={cx(s.item, s.forth)}>
            <div className={s.prizeValue}>
              <div className={s.label}>Forth Prize</div>
              <div className={s.value}>$2,000</div>
            </div>
          </div>
          <div className={cx(s.item, s.fifth)}>
            <div className={s.prizeValue}>
              <div className={s.label}>Fifth Prize</div>
              <div className={s.value}>$1,000</div>
            </div>
          </div>
          <div className={cx(s.item, s.picks)}>
            <div className={s.prizeValue}>
              <div className={s.label}>03 Editor Picks</div>
              <div className={s.value}>$500<sup>/each</sup></div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  )
}
